import styled from 'styled-components/macro';

export const TooltipChart = styled.div`
    background-color: #f6f4f4;
    padding: 8px;
    font-size: 16px;
    font-weight: 700;
    border-radius: 12px;
    border: 1px solid #3e3939;
`;